import { render, staticRenderFns } from "./NewBalanceGroup.vue?vue&type=template&id=4df55c63&scoped=true"
import script from "./NewBalanceGroup.vue?vue&type=script&lang=js"
export * from "./NewBalanceGroup.vue?vue&type=script&lang=js"
import style0 from "./NewBalanceGroup.vue?vue&type=style&index=0&id=4df55c63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df55c63",
  null
  
)

export default component.exports